/* global axios */
import ApiClient from './ApiClient';

class PlatformAnnouncementsAPI extends ApiClient {
  constructor() {
    super('platform_announcements', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  dismiss(announcementId) {
    return axios.post(`${this.url}/${announcementId}/dismiss`);
  }

  markViewed(announcementIds) {
    return axios.post(`${this.url}/mark_viewed`, {
      announcement_ids: announcementIds,
    });
  }
}

export default new PlatformAnnouncementsAPI();
